<template>
  <div class="lmb-table">
    <div class="table-content">
      <q-table
        :data="
          listData.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize
          )
        "
        :header-cell-style="{
          'text-align': 'center',
          'border-color': '#465ECC',
        }"
        :cell-style="{
          color: '#5891FA',
          'font-size': '16px',
          'text-align': 'center',
          'border-color': '#465ECC',
        }"
      >
        <q-table-column prop="index" label="序号" width="50"> </q-table-column>
        <q-table-column v-if="isType === 1" prop="awards" label="奖项" width="150"> </q-table-column>
        <q-table-column :width="isType === 1 ? '200' : '300'" prop="id" label="战队名称"> </q-table-column>
        <q-table-column prop="name" label="战队所属学校"> </q-table-column>
      </q-table>
    </div>
    <q-pagination
      background
      layout="pager"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      :total="total"
    >
    </q-pagination>
  </div>
</template>

<script>
const semifinals = [
  { index: 1, id: '天璇Merak', name: '北京邮电大学' },
  { index: 2, id: '啥也不队', name: '北京邮电大学' },
  { index: 3, id: 'Ganten', name: '北京邮电大学' },
  { index: 4, id: 'KKCU', name: '北京邮电大学' },
  { index: 5, id: 'or4nge', name: '北京航空航天大学' },
  { index: 6, id: 'ylly', name: '北京邮电大学' },
  { index: 7, id: '圣地亚哥皮蛋', name: '山东警察学院' },
  { index: 8, id: '虎皮凤爪', name: '中国人民公安大学' },
  { index: 9, id: '漠南·朝夕', name: '内蒙古警察职业学院' },
  { index: 10, id: '驴肉火烧', name: '中国人民警察大学' },
  { index: 11, id: 'Wake', name: '中央司法警官学院' },
  { index: 12, id: 'PolarDay', name: '吉林警察学院' },
  { index: 13, id: '北极星', name: '黑龙江公安警官职业学院' },
  { index: 14, id: 'TeamWeCylors', name: '辽宁警察学院' },
  { index: 15, id: 'hhhhh', name: '成都信息工程大学' },
  { index: 16, id: 'Nothing', name: '成都信息工程大学' },
  { index: 17, id: 'bhc还不错', name: '成都信息工程大学' },
  { index: 18, id: 'Syclover', name: '成都信息工程大学' },
  { index: 19, id: '曾某人队', name: '成都信息工程大学' },
  { index: 20, id: '服来鸽提交处', name: '河南警察学院' },
  { index: 21, id: 'S1gMa', name: '新疆警察学院' },
  { index: 22, id: '不会签到题', name: '陕西警官职业学院' },
  { index: 23, id: '四川泡菜', name: '四川警察学院' },
  { index: 24, id: 'And-one', name: '山西警察学院' },
  { index: 25, id: 'Nightmare', name: '湖北警官学院' },
  { index: 26, id: '推诚尚勇', name: '甘肃警察职业学院' },
  { index: 27, id: '彩虹七号', name: '铁道警察学院' },
  { index: 28, id: 'TAB1', name: '重庆警察学院' },
  { index: 29, id: '水是一个动词', name: '江苏警官学院' },
  { index: 30, id: '稻草人安全团队', name: '国际关系学院,中北大学' },
  { index: 31, id: 'An4t0le', name: '南京邮电大学' },
  { index: 32, id: 'Forestwo1f_1', name: '南京森林警察学院' },
  { index: 33, id: 'HatTrick2021', name: '江苏海洋大学' },
  { index: 34, id: 'nepnep', name: '中国人民公安大学,江苏科技大学,南京邮电大学' },
  { index: 35, id: '绝望的肉', name: '杭州电子科技大学' },
  { index: 36, id: 'Zodiac', name: '浙江警察学院' },
  { index: 37, id: 'NoneSecc', name: '江苏海洋大学' },
  { index: 38, id: 'DoK0wn', name: '浙江师范大学行知学院' },
  { index: 39, id: 'ms17_010', name: '湖南警察学院' },
  { index: 40, id: '小分队', name: '上海公安学院' },
  { index: 41, id: 'T0rchWOod_2', name: '江西警察学院' },
  { index: 42, id: 'Volcano', name: '广东工业大学' },
  { index: 43, id: '广外女生', name: '广东外语外贸大学' },
  { index: 44, id: 'Kap0k_recrypt', name: '华南理工大学' },
  { index: 45, id: 'G2mtu', name: '广州航海学院' },
  { index: 46, id: '天汉安全团队', name: '广州航海学院,西华大学,新余学院' },
  { index: 47, id: '云曦', name: '云南警官学院' },
  { index: 48, id: '逆浪而行', name: '福建警察学院' },
  { index: 49, id: 'Invictus', name: '贵州警察学院' },
  { index: 50, id: 'X10Sec3', name: '广东警官学院' }
]
const finals = [
  { index: '1', awards: '一等奖', id: '天璇Merak', name: '北京邮电大学' },
  { index: '2', awards: '一等奖', id: 'or4nge', name: '北京航空航天大学' },
  { index: '3', awards: '一等奖', id: '绝望的肉', name: '杭州电子科技大学' },
  { index: '4', awards: '一等奖', id: '虎皮凤爪', name: '中国人民公安大学' },
  { index: '5', awards: '一等奖', id: 'S1gMa', name: '新疆警察学院' },
  {
    index: '6',
    awards: '一等奖',
    id: 'nepnep',
    name: '中国人民公安大学；江苏科技大学；南京邮电大学'
  },
  { index: '7', awards: '一等奖', id: '曾某人队', name: '成都信息工程大学' },
  { index: '8', awards: '一等奖', id: '啥也不队', name: '北京邮电大学' },
  { index: '9', awards: '一等奖', id: 'ylly', name: '北京邮电大学' },
  { index: '10', awards: '一等奖', id: 'DoK0wn', name: '浙江师范大学行知学院' },
  { index: '11', awards: '二等奖', id: 'G2mtu', name: '广州航海学院' },
  { index: '12', awards: '二等奖', id: 'An4t0le', name: '南京邮电大学' },
  { index: '13', awards: '二等奖', id: '驴肉火烧', name: '中国人民警察大学' },
  { index: '14', awards: '二等奖', id: 'KKCU', name: '北京邮电大学' },
  { index: '15', awards: '二等奖', id: '推诚尚勇', name: '甘肃警察职业学院' },
  { index: '16', awards: '二等奖', id: 'Ganten', name: '北京邮电大学' },
  { index: '17', awards: '二等奖', id: 'hhhhh', name: '成都信息工程大学' },
  { index: '18', awards: '二等奖', id: 'HatTrick2021', name: '江苏海洋大学' },
  { index: '19', awards: '二等奖', id: '服来鸽提交处', name: '河南警察学院' },
  {
    index: '20',
    awards: '二等奖',
    id: '稻草人安全团队',
    name: '国际关系学院；中北大学；中国人民警察大学'
  },
  {
    index: '21',
    awards: '三等奖',
    id: 'Forestwo1f_1',
    name: '南京森林警察学院'
  },
  { index: '22', awards: '三等奖', id: '圣地亚哥皮蛋', name: '山东警察学院' },
  {
    index: '23',
    awards: '三等奖',
    id: '漠南·朝夕',
    name: '内蒙古警察职业学院'
  },
  { index: '24', awards: '三等奖', id: 'Syclover', name: '成都信息工程大学' },
  { index: '25', awards: '三等奖', id: '逆浪而行', name: '福建警察学院' },
  { index: '26', awards: '三等奖', id: '四川泡菜', name: '四川警察学院' },
  { index: '27', awards: '三等奖', id: '广外女生', name: '广东外语外贸大学' },
  { index: '28', awards: '三等奖', id: 'Nothing', name: '成都信息工程大学' },
  { index: '29', awards: '三等奖', id: '云曦', name: '云南警官学院' },
  { index: '30', awards: '三等奖', id: 'Kap0k_recrypt', name: '华南理工大学' },
  { index: '31', awards: '三等奖', id: 'bhc还不错', name: '成都信息工程大学' },
  {
    index: '32',
    awards: '三等奖',
    id: '天汉安全团队',
    name: '广州航海学院；西华大学；新余学院'
  },
  { index: '33', awards: '三等奖', id: 'TAB1', name: '重庆警察学院' },
  { index: '34', awards: '三等奖', id: 'Volcano', name: '广东工业大学' },
  {
    index: '35',
    awards: '三等奖',
    id: '北极星',
    name: '黑龙江公安警官职业学院'
  },
  { index: '36', awards: '优胜奖', id: 'MS17_010', name: '湖南警察学院' },
  { index: '37', awards: '优胜奖', id: 'Nightmare', name: '湖北警官学院' },
  { index: '38', awards: '优胜奖', id: 'Zodiac', name: '浙江警察学院' },
  { index: '39', awards: '优胜奖', id: 'Wake', name: '中央司法警官学院' },
  { index: '40', awards: '优胜奖', id: 'T1deS', name: '辽宁警察学院' },
  { index: '41', awards: '优胜奖', id: 'Invictus', name: '贵州警察学院' },
  { index: '42', awards: '优胜奖', id: 'PolarDay', name: '吉林警察学院' },
  { index: '43', awards: '优胜奖', id: '彩虹七号', name: '铁道警察学院' },
  { index: '44', awards: '优胜奖', id: 'TorchWood_2', name: '江西警察学院' },
  { index: '45', awards: '优胜奖', id: 'NoneSecc', name: '江苏海洋大学' },
  { index: '46', awards: '优胜奖', id: 'And-one', name: '山西警察学院' },
  { index: '47', awards: '优胜奖', id: '不会签到题', name: '陕西警官职业学院' },
  { index: '48', awards: '优胜奖', id: 'X10sec3', name: '广东警官学院' },
  { index: '49', awards: '优胜奖', id: '小分队', name: '上海公安学院' }
]
export default {
  data () {
    return {
      total: 50,
      currentPage: 1,
      pageSize: 10,
      listData: finals,
      isType: 1
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList (input = '') {
      console.log(this.isType)
      console.log('getList', input)
      this.listData = finals.filter((item, index) => {
        if (item.id.includes(input)) {
          return item
        }
      })
      this.total = this.listData.length
    },
    tabCheck (active) {
      this.isType = active
      this.listData = this.isType === 1 ? finals : semifinals
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .q-table {
  border-bottom: 1px solid #465ECC;
  & th {
    background-color: #243074;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
    height: 50px;
  }
  & tr {
    background-color: #02021c;
    height: 50px;
  }
}
/deep/ .q-table::before {
  background-color: #02021c;
}
/deep/ .q-table:hover {
  background-color: #02021c;
}
/deep/ .q-pagination .q-pagination__button {
  border: 1px solid #465ecc;
  background-color: #141c4c;
}
.lmb-table {
  text-align: center;
}
.table-content {
  border: 1px solid #465ecc;
  height: 550px;
}
.q-pagination {
  margin-top: 20px;
}
</style>
